import { localizedF } from "js/includes/common/utils"

export const defaultDeviceDataSyncAttributes = [
  { value: "serialNumber", text: localizedF("configuration.psa.serialNumber") },
  { value: "osInfo", text: localizedF("configuration.psa.osInfo") },
  { value: "model", text: localizedF("configuration.psa.model") },
  { value: "productKey", text: localizedF("configuration.psa.productKey") },
  { value: "nodeUrl", text: localizedF("configuration.psa.nodeUrl") },
  { value: "teamViewerUrl", text: localizedF("configuration.psa.teamViewerUrl") },
  { value: "defaultGateway", text: localizedF("configuration.psa.defaultGateway") },
  { value: "cpuSPeed", text: localizedF("configuration.psa.cpuSpeed") },
  { value: "ram", text: localizedF("configuration.psa.ram") },
  { value: "macAddress", text: localizedF("configuration.psa.macAddress") },
  { value: "lastLoginName", text: localizedF("configuration.psa.lastLoginName") },
  { value: "localHardDrives", text: localizedF("configuration.psa.localHardDrives") },
  { value: "privateIpAddress", text: localizedF("configuration.psa.privateIpAddresses") },
]
